// extracted by mini-css-extract-plugin
module.exports = {"bankCheck":"styles__bankCheck__1bEeU","bankCheckImg":"styles__bankCheckImg__3JRFN","bankCheckbtn":"styles__bankCheckbtn__1kIVN"};